export const overdue = '/reports';
export const completedCounts = '/reports/completed-counts';
export const itemsCounted = '/reports/items-counted';
